import { DefaultURLs } from './constants';

export const capitalizeFirstChar = (text) => text[0]?.toUpperCase() + text.slice(1);

/**
* Opens a URL in a new tab/window
* @param {string} url - The URL to open
* @param {string} target - The target window (default: '_blank')
* @param {string} features - Optional window features
*/
export const openLink = (url, target = '_blank', features = '') => {
    if (!url) {
        console.warn('openLink: URL is required');
        return;
    }

    try {
        window.open(url, target, features);
    } catch (error) {
        console.error('openLink: Failed to open link', error);
    }
};

export function openSAASTerms () {
    openLink(DefaultURLs.SAAS_TERMS);
};
